import {
  Autocomplete,
  Box,
  InputLabel,
  TextField,
  Typography,
} from "@mui/material";
import CustomInput from "../../../../../../components/CustomInput";
import OtpInput from "../../../OtpInput";

import React, { useState } from "react";
import CustomAutoComple from "../../../../../../components/CustomAutoComplete";
import CustomSelectOption from "../../../../../../components/CustomSelectOption";
import CustomInputLabel from "../../../../../../components/CustomInputLabel";

export default function CompanyInfo() {
  const [otpState, setOtpState] = useState(true);

  const top100Films = [
    { label: "تهران", id: 1994 },
    { label: "شیراز", id: 1972 },
    { label: "اصفهان", id: 1974 },
  ];

  return (
    <>
      <Typography
        sx={{
          textAlign: "center",
          fontSize: "16px",
          fontWeight: "600",
          color: "secondary.main",
        }}
        variant="h3"
      >
        ثبت‌نام شرکت حمل و نقل
      </Typography>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          flex: "1",
        }}
      >
        <Box
          sx={{
            flex: "1",
            // overflow: "auto",
            px: 1,
            // maxHeight: {
            //   xs: "auto",
            //   sm: "400px",
            //   md: "300px",
            //   lg: "300px",
            //   xl: "500px",
            // }, // Limiting the height
          }}
        >
          <Box
            sx={{
              mt: "16px",
            }}
          >
            <CustomInputLabel required htmlFor="outlined-adornment-amount">
              {"نام شرکت"}
            </CustomInputLabel>

            <CustomInput placHolder="نام شرکت را وارد کنید..." />
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <Box
              sx={{
                mt: "16px",
                flex: 1,
              }}
            >
              <CustomInputLabel required htmlFor="outlined-adornment-amount">
                {"کد سازمانی شرکت"}
              </CustomInputLabel>

              <CustomInput placHolder="کد سازمانی را وارد کنید" />
            </Box>
            <Box
              sx={{
                mt: "16px",
                flex: 1,
              }}
            >
              <CustomInputLabel required htmlFor="outlined-adornment-amount">
                {"شناسه ملی شرکت"}
              </CustomInputLabel>

              <CustomInput placHolder="شناسه 11 رقمی ملی شرکت" />
            </Box>
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <Box
              sx={{
                mt: "16px",
                flex: 1,
              }}
            >
              <CustomInputLabel required htmlFor="outlined-adornment-amount">
                {"تلفن شرکت"}
              </CustomInputLabel>

              <CustomInput placHolder="شماره" />
            </Box>
            <Box
              sx={{
                mt: "16px",
                flex: 1,
              }}
            >
              <CustomInputLabel required htmlFor="outlined-adornment-amount">
                {"کد پستی شرکت"}
              </CustomInputLabel>

              <CustomInput placHolder="کد پستی شرکت را وارد کنید" />
            </Box>
          </Box>
          <Box
            sx={{
              mt: "16px",
            }}
          >
            <CustomInputLabel required htmlFor="outlined-adornment-amount">
              {"استان محل فعالیت"}
            </CustomInputLabel>

            <CustomAutoComple
              placHolder="استان را انتخاب کنید"
              options={top100Films}
            />
          </Box>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <Box
              sx={{
                mt: "16px",
                flex: 1,
              }}
            >
              <CustomInputLabel required htmlFor="outlined-adornment-amount">
                {"شهرستان محل فعالیت"}
              </CustomInputLabel>

              <CustomAutoComple
                placHolder="انتخاب کنید"
                options={top100Films}
              />
            </Box>
            <Box
              sx={{
                mt: "16px",
                flex: 1,
              }}
            >
              <CustomInputLabel required htmlFor="outlined-adornment-amount">
                {"حوزه فعالیت شرکت"}
              </CustomInputLabel>

              <CustomSelectOption
                selectFor={"year"}
                handleChange={() => console.log("sdsd")}
                options={[
                  {
                    label: "بزرگ مقیاس",
                    value: 1,
                  },
                  {
                    label: "کوچک مقیاس",
                    value: 2,
                  },
                ]}
                value={1}
              />
            </Box>
          </Box>

          <Box
            sx={{
              mt: "16px",
              flex: 1,
            }}
          >
            <InputLabel
              sx={{
                color: "primary.main",
                fontWeight: 600,
                marginBottom: "8px",
                fontSize: "14px",
              }}
              htmlFor="outlined-adornment-amount"
            >
              {"آدرس شرکت:"}
            </InputLabel>

            <CustomInput
              textArea
              placHolder="آدرس شرکت را این قسمت وارد کنید..."
            />
          </Box>
          {/* {otpState && <OtpInput />} */}
        </Box>
      </Box>
    </>
  );
}
